import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "my-3 p-3 bg-app" };
const _hoisted_2 = {
    id: "toolbar-panel",
    class: "mb-2"
};
const _hoisted_3 = { class: "toolbar navbar px-3" };
const _hoisted_4 = { class: "nav nav-pills nav-fill w-lg-40" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-file-earmark-image mx-1 fz-22" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-calendar2-week mx-1 fz-22" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "header text-center w-60 fw-bold fz-26 text-white nunito d-none d-md-block" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Preview")
], -1);
const _hoisted_8 = {
    id: "workarea-panel",
    class: "d-flex flex-column flex-md-row"
};
const _hoisted_9 = {
    id: "options-panel",
    class: "w-lg-40"
};
const _hoisted_10 = { key: 0 };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-center nunito fw-bold fz-22 py-2" }, "Calendar Templates", -1);
const _hoisted_12 = { class: "d-flex flex-column mt-3" };
const _hoisted_13 = { class: "d-flex flex-wrap" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "poppins fw-600 fz-20" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "poppins fw-600 fz-20" };
const _hoisted_20 = {
    key: 0,
    class: "premium-title d-none"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("img", { src: "/images/premium-icon.png" }, null, -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-center nunito fw-bold fz-24 py-2" }, "Premium Templates", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("img", { src: "/images/premium-icon.png" }, null, -1);
const _hoisted_24 = [
    _hoisted_21,
    _hoisted_22,
    _hoisted_23
];
const _hoisted_25 = {
    key: 1,
    class: "d-none flex-wrap chapuza"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src"];
const _hoisted_28 = { class: "poppins fw-600 fz-20" };
const _hoisted_29 = {
    key: 1,
    class: "position-relative"
};
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-center nunito fw-bold fz-22 py-2 mb-3" }, "Calendar Settings", -1);
const _hoisted_31 = { class: "mb-3" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Week Starts:", -1);
const _hoisted_33 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Group"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Sunday", -1);
const _hoisted_35 = [
    _hoisted_34
];
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Monday", -1);
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = { class: "mb-3" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Day Names:", -1);
const _hoisted_40 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Group"
};
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Long", -1);
const _hoisted_42 = [
    _hoisted_41
];
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Short", -1);
const _hoisted_44 = [
    _hoisted_43
];
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Shorter", -1);
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = { class: "mb-3" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block float-start" }, "Language:", -1);
const _hoisted_49 = { class: "dropdown float-start" };
const _hoisted_50 = ["onClick"];
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("div", { style: { "height": "37px" } }, null, -1);
const _hoisted_52 = { class: "mb-3 d-flex" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Title Size:", -1);
const _hoisted_54 = { class: "mb-3" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Title Style:", -1);
const _hoisted_56 = {
    class: "btn-group",
    role: "group",
    "aria-label": "Group"
};
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Month", -1);
const _hoisted_58 = [
    _hoisted_57
];
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("div", { class: "btn-content" }, "Month and Year", -1);
const _hoisted_60 = [
    _hoisted_59
];
const _hoisted_61 = { class: "mb-3" };
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Title Color:", -1);
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("span", { class: "text-white nunito fw-bold" }, "Click to change", -1);
const _hoisted_64 = [
    _hoisted_63
];
const _hoisted_65 = { class: "color-dialog" };
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("h4", null, "Title Color", -1);
const _hoisted_67 = { class: "mb-3" };
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block float-start" }, "Title Font:", -1);
const _hoisted_69 = {
    key: 4,
    class: "d-flex w-100 flex-column pt-4"
};
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-center nunito fw-bold fz-22 py-2 mb-3" }, "Quote Settings", -1);
const _hoisted_71 = { class: "my-3 text-center" };
const _hoisted_72 = {
    style: { "width": "32px", "padding": "5px 5px 5px 0" },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
const _hoisted_73 = /*#__PURE__*/ _createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\"></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></g><g id=\"SVGRepo_iconCarrier\"><path d=\"M15 4V2\"></path> <path d=\"M15 16v-2\"></path> <path d=\"M8 9h2\"></path> <path d=\"M20 9h2\"></path> <path d=\"M17.8 11.8L19 13\"></path> <path d=\"M15 9h0\"></path> <path d=\"M17.8 6.2L19 5\"></path> <path d=\"M3 21l9-9\"></path> <path d=\"M12.2 6.2L11 5\"></path></g>", 3);
const _hoisted_76 = [
    _hoisted_73
];
const _hoisted_77 = {
    style: { "width": "32px", "padding": "5px 5px 5px 0" },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
}, null, -1);
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_80 = /*#__PURE__*/ _createElementVNode("g", { id: "SVGRepo_iconCarrier" }, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M11 2L13 3.99545L12.9408 4.05474M13 18.0001L11 19.9108L11.0297 19.9417M12.9408 4.05474L11 6M12.9408 4.05474C12.6323 4.01859 12.3183 4 12 4C7.58172 4 4 7.58172 4 12C4 14.5264 5.17107 16.7793 7 18.2454M17 5.75463C18.8289 7.22075 20 9.47362 20 12C20 16.4183 16.4183 20 12 20C11.6716 20 11.3477 19.9802 11.0297 19.9417M13 22.0001L11.0297 19.9417",
        stroke: "#000000",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    })
], -1);
const _hoisted_81 = [
    _hoisted_78,
    _hoisted_79,
    _hoisted_80
];
const _hoisted_82 = { class: "mt-3 d-flex" };
const _hoisted_83 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Quote Size:", -1);
const _hoisted_84 = { class: "my-3" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block" }, "Quote Color:", -1);
const _hoisted_86 = /*#__PURE__*/ _createElementVNode("span", { class: "text-white nunito fw-bold" }, "Click to change", -1);
const _hoisted_87 = [
    _hoisted_86
];
const _hoisted_88 = { class: "color-dialog" };
const _hoisted_89 = /*#__PURE__*/ _createElementVNode("h4", null, "Quote Color", -1);
const _hoisted_90 = { class: "mb-3" };
const _hoisted_91 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-25 d-inline-block float-start" }, "Quote Font:", -1);
const _hoisted_92 = {
    key: 5,
    class: "mb-3 clearfix"
};
const _hoisted_93 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-50 d-inline-block" }, "Title Border Color:", -1);
const _hoisted_94 = /*#__PURE__*/ _createElementVNode("span", { class: "text-black nunito fw-bold" }, "Click to change", -1);
const _hoisted_95 = [
    _hoisted_94
];
const _hoisted_96 = {
    key: 6,
    class: "color-dialog"
};
const _hoisted_97 = /*#__PURE__*/ _createElementVNode("h4", null, "Title Border Color", -1);
const _hoisted_98 = {
    key: 7,
    class: "mb-3 d-flex"
};
const _hoisted_99 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-50 d-inline-block" }, "Watercolor Shape Size:", -1);
const _hoisted_100 = {
    key: 8,
    class: "mb-3 clearfix"
};
const _hoisted_101 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-50 d-inline-block" }, "Watercolor Shape Color:", -1);
const _hoisted_102 = /*#__PURE__*/ _createElementVNode("span", { class: "text-white nunito fw-bold" }, "Click to change", -1);
const _hoisted_103 = [
    _hoisted_102
];
const _hoisted_104 = {
    key: 9,
    class: "color-dialog"
};
const _hoisted_105 = /*#__PURE__*/ _createElementVNode("h4", null, "Watercolor Shape Color", -1);
const _hoisted_106 = {
    key: 10,
    class: "mb-3 clearfix"
};
const _hoisted_107 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-50 d-inline-block" }, "Watercolor Shape:", -1);
const _hoisted_108 = ["src"];
const _hoisted_109 = {
    key: 11,
    class: "mb-3 clearfix"
};
const _hoisted_110 = /*#__PURE__*/ _createElementVNode("span", { class: "nunito fz-18 ms-2 me-3 w-50 d-inline-block" }, "Header Background:", -1);
const _hoisted_111 = ["src"];
const _hoisted_112 = { class: "text-center" };
const _hoisted_113 = {
    id: "preview-panel",
    class: "mw-60 d-flex flex-column"
};
const _hoisted_114 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-center nunito fw-bold fz-22 py-2 my-4 d-md-none" }, "Preview", -1);
const _hoisted_115 = { class: "text-center w-100" };
const _hoisted_116 = { class: "w-md-60 float-md-end mt-4 mt-md-0 position-relative" };
const _hoisted_117 = { class: "make-button-tooltip" };
const _hoisted_118 = /*#__PURE__*/ _createElementVNode("div", { class: "arrow-left" }, null, -1);
import { ref } from 'vue';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useInitStore } from '../stores/init';
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
import { useCalendarImagesStore } from '../stores/calendarImages';
import VueSimpleRangeSlider from "vue-simple-range-slider";
import "vue-simple-range-slider/css";
import { ColorPicker } from 'vue-accessible-color-picker';
import FontPicker from '../components/FontPicker.vue';
import WatercolorShapeDialog from '../components/WatercolorShapeDialog.vue';
import BackgroundDialog from '../components/BackgroundDialog.vue';
import EditQuoteDialog from '../components/EditQuoteDialog.vue';
import { useRoute, useRouter } from 'vue-router';
import WebFontLoader from 'webfontloader';
import html2canvas from 'html2canvas';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HomeView',
    setup(__props) {
        _useCssVars(_ctx => ({
            "cb18c27a": (_unref(calendarSettingsStore).title.fontSize + 'px'),
            "3f9d68d3": (_unref(calendarSettingsStore).title.color),
            "37129d4c": (_unref(calendarSettingsStore).title.fontFace.fontName),
            "b6570f20": (_unref(calendarSettingsStore).quote.fontFace.fontName),
            "729fdf93": (_unref(calendarSettingsStore).title.shadowColor)
        }));
        const router = useRouter();
        const route = useRoute();
        const calendarSettingsStore = useCalendarSettingsStore();
        const initStore = useInitStore();
        const calendarTemplatesStore = useCalendarTemplatesStore();
        const calendarImagesStore = useCalendarImagesStore();
        const selectedIndex = ref(1);
        const dropdownVisible = ref(false);
        const selectedLanguage = ref('English');
        const showDialogs = ref({
            color: false,
            quoteColor: false,
            borderColor: false,
            watercolorShapeColor: false,
            watercolorShape: false,
            editQuote: false,
            calBackground: false,
            makeButtonTooltip: false,
            calendarPreview: true,
        });
        WebFontLoader.load({
            google: { families: ['Caveat Brush', 'Rubik Bubbles', 'Nerko One', 'Allura'] },
            custom: {
                families: ['Brusher', 'Carnation'],
                urls: ['/css/ccmfonts.css']
            }
        });
        const quotesTemplateRef = ref(null);
        function selectIndex(index) {
            selectedIndex.value = index;
        }
        function setLanguage(lang) {
            calendarSettingsStore.setLanguage(lang);
            selectedLanguage.value = calendarSettingsStore.languages.find(x => x.locale === lang).name;
            dropdownVisible.value = !dropdownVisible;
        }
        function updateColor(eventData) {
            calendarSettingsStore.title.color = eventData.cssColor;
        }
        function updateQuoteColor(eventData) {
            calendarSettingsStore.quote.color = eventData.cssColor;
        }
        function updateBorderColor(eventData) {
            calendarSettingsStore.title.shadowColor = eventData.cssColor;
        }
        function updateWatercolorShapeColor(eventData) {
            calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].settings.shapeColor = eventData.cssColor;
        }
        function updateWaterColorShape() {
            let random = Math.floor(Math.random() * (38 - 1 + 1)) + 1;
            calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].settings.shapeFile = 'watercolor-' + random + '.png';
        }
        function updateFontFace(event) {
            console.log(event);
            calendarSettingsStore.title.fontFace = event;
        }
        function imgToCanvas(img, color) {
            /*
                Dibujo un canvas con un rectángulo del color con el que colorear la imagen
            */
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.ctx = canvas.getContext('2d');
            canvas.ctx.fillStyle = color;
            canvas.ctx.fillRect(0, 0, canvas.width, canvas.height);
            /*
                Dibujo un canvas con la "shape" y un fondo blanco (el fondo blanco es importante)
            */
            const canvas2 = document.createElement('canvas');
            canvas2.width = img.width;
            canvas2.height = img.height;
            canvas2.ctx = canvas2.getContext('2d');
            canvas2.ctx.fillStyle = '#ffffff';
            canvas2.ctx.fillRect(0, 0, canvas2.width, canvas2.height);
            canvas2.ctx.drawImage(img, 0, 0, img.width, img.width * img.height / img.width);
            /*
                Dibujo el segundo canvas sobre el primero con el tipo de composición hard-light
            */
            canvas.ctx.globalCompositeOperation = 'hard-light';
            canvas.ctx.drawImage(canvas2, 0, 0, img.width, img.width * img.height / img.width);
            return canvas;
        }
        async function loadImage(img) {
            const imageLoadPromise = new Promise(resolve => {
                img.onload = resolve;
            });
            await imageLoadPromise;
            return img;
        }
        async function makeCalendar() {
            let calendarNode = document.querySelectorAll('.preview-sheet')[0]?.cloneNode(true);
            let shapes = [];
            document.querySelectorAll('.color-mask').forEach(function (el) {
                shapes.push({
                    color: window.getComputedStyle(el).backgroundColor,
                    width: window.getComputedStyle(el).width.replace('px', ''),
                    height: window.getComputedStyle(el).height.replace('px', ''),
                });
            });
            async function colorizeShapes(node) {
                const loopPromise = new Promise(resolve => {
                    node.querySelectorAll('.color-mask').forEach(async function (el, index, array) {
                        let color = shapes[index].color;
                        let img = el.querySelector('img');
                        img.width = shapes[index].width;
                        img.height = shapes[index].height;
                        let shapeImg = await loadImage(el.querySelector('img'));
                        let canvas;
                        canvas = imgToCanvas(shapeImg, color);
                        const div = document.createElement('div');
                        div.classList.add('text-center', 'position-absolute', 'w-100');
                        div.appendChild(canvas);
                        el.replaceWith(div);
                        if (index === array.length - 1) {
                            resolve('fin');
                        }
                    });
                });
                await loopPromise;
                return node;
            }
            calendarNode?.querySelector('.fc-button-group')?.setAttribute('data-html2canvas-ignore', '');
            if (calendarNode?.querySelectorAll('.color-mask').length > 0) {
                calendarNode = await colorizeShapes(calendarNode);
            }
            if (calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].settings?.headerBackgroundImage != null) {
                let img = document.createElement('img');
                img.src = '/images/backgrounds/' + calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].settings.headerBackgroundImage;
                let div = document.createElement('div');
                div.classList.add('header-background');
                div.appendChild(img);
                calendarNode.querySelector('.fc .fc-toolbar.fc-header-toolbar')?.classList.add('no-background');
                calendarNode.querySelector('.fc .fc-toolbar.fc-header-toolbar')?.appendChild(div);
            }
            if (calendarNode != null) {
                showDialogs.value.calendarPreview = false;
                document.querySelectorAll('.preview-sheet')[0].parentNode?.appendChild(calendarNode);
                html2canvas(calendarNode, {
                    scale: 2.58,
                    windowWidth: 1920,
                    //width: 1240,
                    //height: 1755,
                }).then(function (canvas) {
                    calendarSettingsStore.calendarCanvas = canvas;
                    document.querySelectorAll('.preview-sheet')[1].remove();
                    showDialogs.value.calendarPreview = true;
                    //document.body.appendChild(canvas);
                });
            }
        }
        async function makeCalendarClick() {
            if (calendarImagesStore.imageSelected || calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].name == 'quotes_calendar') {
                if (initStore.isLoggedIn) {
                    await makeCalendar();
                    router.push('/make-free');
                    //if (calendarSettingsStore.calendarCanvas != null) {
                    //    calendarSettingsStore.saveImage(calendarSettingsStore.calendarCanvas.toDataURL(),'calendar');
                    //}       
                }
                else {
                    if (calendarTemplatesStore.templates[calendarTemplatesStore.templateIndex].premium) {
                        router.push('/make-premium');
                    }
                    else {
                        makeCalendar();
                        router.push('/make-free');
                    }
                }
            }
        }
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("nav", _hoisted_4, [
                            _createElementVNode("a", {
                                class: _normalizeClass(["nav-link", { "active": (selectedIndex.value == 1) }]),
                                "aria-current": "page",
                                href: "#",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (selectIndex(1)), ["prevent"]))
                            }, [
                                _hoisted_5,
                                _createTextVNode("Templates ")
                            ], 2),
                            _createElementVNode("a", {
                                class: _normalizeClass(["nav-link", { "active": (selectedIndex.value == 2) }]),
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (selectIndex(2)), ["prevent"]))
                            }, [
                                _hoisted_6,
                                _createTextVNode("Settings ")
                            ], 2)
                        ]),
                        _hoisted_7
                    ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        ((selectedIndex.value == 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarTemplatesStore).freeTemplates, (template) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: _normalizeClass(["calendar-template", { active: _unref(calendarTemplatesStore).templateIndex == _unref(calendarTemplatesStore).getTemplateIndex(template.name) }]),
                                                onClick: ($event) => {
                                                    _unref(calendarTemplatesStore).templateIndex = _unref(calendarTemplatesStore).getTemplateIndex(template.name);
                                                    _unref(router).push(_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).getTemplateIndex(template.name)].path);
                                                }
                                            }, [
                                                _createElementVNode("img", {
                                                    src: template['img'],
                                                    class: "template_thumb"
                                                }, null, 8, _hoisted_15),
                                                _createElementVNode("h3", _hoisted_16, _toDisplayString(template.title), 1)
                                            ], 10, _hoisted_14));
                                        }), 256)),
                                        (_unref(initStore).isLoggedIn)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(calendarTemplatesStore).premiumTemplates, (template) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass(["calendar-template", { active: _unref(calendarTemplatesStore).templateIndex == _unref(calendarTemplatesStore).getTemplateIndex(template.name) }]),
                                                    onClick: ($event) => {
                                                        _unref(calendarTemplatesStore).templateIndex = _unref(calendarTemplatesStore).getTemplateIndex(template.name);
                                                        _unref(router).push(_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).getTemplateIndex(template.name)].path);
                                                    }
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: template['img'],
                                                        class: "template_thumb"
                                                    }, null, 8, _hoisted_18),
                                                    _createElementVNode("h3", _hoisted_19, _toDisplayString(template.title), 1)
                                                ], 10, _hoisted_17));
                                            }), 256))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (!_unref(initStore).isLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_24))
                                        : _createCommentVNode("", true),
                                    (!_unref(initStore).isLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarTemplatesStore).premiumTemplates, (template) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass(["calendar-template", { active: _unref(calendarTemplatesStore).templateIndex == _unref(calendarTemplatesStore).getTemplateIndex(template.name) }]),
                                                    onClick: ($event) => {
                                                        _unref(calendarTemplatesStore).templateIndex = _unref(calendarTemplatesStore).getTemplateIndex(template.name);
                                                        _unref(router).push(_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).getTemplateIndex(template.name)].path);
                                                    }
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: template['img'],
                                                        class: "template_thumb"
                                                    }, null, 8, _hoisted_27),
                                                    _createElementVNode("h3", _hoisted_28, _toDisplayString(template.title), 1)
                                                ], 10, _hoisted_26));
                                            }), 256))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        ((selectedIndex.value == 2))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                (_unref(route).name === 'watercolor_template')
                                    ? _withDirectives((_openBlock(), _createBlock(WatercolorShapeDialog, {
                                        key: 0,
                                        onCloseDialog: _cache[2] || (_cache[2] = ($event) => (showDialogs.value.watercolorShape = false))
                                    }, null, 512)), [
                                        [_vShow, showDialogs.value.watercolorShape]
                                    ])
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'premium_photo2')
                                    ? _withDirectives((_openBlock(), _createBlock(BackgroundDialog, {
                                        key: 1,
                                        onCloseDialog: _cache[3] || (_cache[3] = ($event) => (showDialogs.value.calBackground = false))
                                    }, null, 512)), [
                                        [_vShow, showDialogs.value.calBackground]
                                    ])
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'quotes_calendar')
                                    ? _withDirectives((_openBlock(), _createBlock(EditQuoteDialog, {
                                        key: 2,
                                        onCloseDialog: _cache[4] || (_cache[4] = ($event) => (showDialogs.value.editQuote = false))
                                    }, null, 512)), [
                                        [_vShow, showDialogs.value.editQuote]
                                    ])
                                    : _createCommentVNode("", true),
                                _hoisted_30,
                                (_unref(route).name === 'watercolor_template' || _unref(route).name === 'premium_photo')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 3,
                                        class: _normalizeClass(["overlay", { dnone: (!(showDialogs.value.color || showDialogs.value.borderColor || showDialogs.value.watercolorShapeColor)) }])
                                    }, null, 2))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.firstDay == 0) }]),
                                            type: "button",
                                            onClick: _cache[5] || (_cache[5] = ($event) => (_unref(calendarSettingsStore).setFirstDay(0)))
                                        }, _hoisted_35, 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.firstDay == 1) }]),
                                            type: "button",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (_unref(calendarSettingsStore).setFirstDay(1)))
                                        }, _hoisted_37, 2)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                    _hoisted_39,
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.dayHeaderFormat.weekday == 'long') }]),
                                            type: "button",
                                            onClick: _cache[7] || (_cache[7] = ($event) => (_unref(calendarSettingsStore).setDayNames('long')))
                                        }, _hoisted_42, 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.dayHeaderFormat.weekday == 'short') }]),
                                            type: "button",
                                            onClick: _cache[8] || (_cache[8] = ($event) => (_unref(calendarSettingsStore).setDayNames('short')))
                                        }, _hoisted_44, 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.dayHeaderFormat.weekday == 'narrow') }]),
                                            type: "button",
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_unref(calendarSettingsStore).setDayNames('narrow')))
                                        }, _hoisted_46, 2)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("button", {
                                            class: "btn btn-secondary btn-md dropdown-toggle",
                                            type: "button",
                                            onClick: _cache[10] || (_cache[10] = ($event) => (dropdownVisible.value = !dropdownVisible.value))
                                        }, _toDisplayString(selectedLanguage.value), 1),
                                        _createElementVNode("ul", {
                                            class: _normalizeClass(["dropdown-menu", { dnone: (!dropdownVisible.value) }])
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarSettingsStore).languages, (language) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: "dropdown-item",
                                                    onClick: ($event) => (setLanguage(language.locale))
                                                }, _toDisplayString(language.name), 9, _hoisted_50));
                                            }), 256))
                                        ], 2)
                                    ]),
                                    _hoisted_51
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createVNode(_unref(VueSimpleRangeSlider), {
                                        min: 0,
                                        max: 120,
                                        modelValue: _unref(calendarSettingsStore).title.fontSize,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(calendarSettingsStore).title.fontSize) = $event))
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.titleFormat.year !== 'numeric') }]),
                                            type: "button",
                                            onClick: _cache[12] || (_cache[12] = ($event) => (_unref(calendarSettingsStore).calendarOptions.titleFormat = { year: undefined, month: 'long' }))
                                        }, _hoisted_58, 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["btn btn-secondary btn-md", { active: (_unref(calendarSettingsStore).calendarOptions.titleFormat.year === 'numeric') }]),
                                            type: "button",
                                            onClick: _cache[13] || (_cache[13] = ($event) => (_unref(calendarSettingsStore).calendarOptions.titleFormat = { year: 'numeric', month: 'long' }))
                                        }, _hoisted_60, 2)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createElementVNode("div", {
                                        class: "picked-color text-center",
                                        style: _normalizeStyle({ 'background-color': _unref(calendarSettingsStore).title.color }),
                                        onClick: _cache[14] || (_cache[14] = ($event) => (showDialogs.value.color = !showDialogs.value.color))
                                    }, _hoisted_64, 4)
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "aria-label": "Close",
                                        onClick: _cache[15] || (_cache[15] = ($event) => (showDialogs.value.color = !showDialogs.value.color))
                                    }),
                                    _createVNode(_unref(ColorPicker), {
                                        color: _unref(calendarSettingsStore).title.color,
                                        onColorChange: updateColor
                                    }, null, 8, ["color"])
                                ], 512), [
                                    [_vShow, showDialogs.value.color]
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                    _hoisted_68,
                                    _createVNode(FontPicker, {
                                        defaultFont: _unref(calendarSettingsStore).title.fontFace.fontName,
                                        onFontChanged: _cache[16] || (_cache[16] = ($event) => (_unref(calendarSettingsStore).title.fontFace = $event))
                                    }, null, 8, ["defaultFont"])
                                ]),
                                (_unref(route).name === 'quotes_calendar')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                        _hoisted_70,
                                        _createElementVNode("div", _hoisted_71, [
                                            _createElementVNode("button", {
                                                class: "btn btn-secondary btn-md fz-20 mx-3 px-3",
                                                style: { "border-radius": "5px" },
                                                type: "button",
                                                onClick: _cache[17] || (_cache[17] = ($event) => (showDialogs.value.editQuote = true))
                                            }, [
                                                (_openBlock(), _createElementBlock("svg", _hoisted_72, _hoisted_76)),
                                                _createTextVNode(" Edit Quote ")
                                            ]),
                                            _createElementVNode("button", {
                                                class: "btn btn-secondary btn-md fz-20 mx-3 px-3",
                                                style: { "border-radius": "5px" },
                                                type: "button",
                                                onClick: _cache[18] || (_cache[18] = ($event) => (_unref(calendarSettingsStore).updateQuoteBackground()))
                                            }, [
                                                (_openBlock(), _createElementBlock("svg", _hoisted_77, _hoisted_81)),
                                                _createTextVNode(" Background ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_82, [
                                            _hoisted_83,
                                            _createVNode(_unref(VueSimpleRangeSlider), {
                                                min: 0,
                                                max: 120,
                                                modelValue: _unref(calendarSettingsStore).quote.fontSize,
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(calendarSettingsStore).quote.fontSize) = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_84, [
                                            _hoisted_85,
                                            _createElementVNode("div", {
                                                class: "picked-color text-center",
                                                style: _normalizeStyle({ 'background-color': _unref(calendarSettingsStore).quote.color }),
                                                onClick: _cache[20] || (_cache[20] = ($event) => (showDialogs.value.quoteColor = !showDialogs.value.quoteColor))
                                            }, _hoisted_87, 4)
                                        ]),
                                        _withDirectives(_createElementVNode("div", _hoisted_88, [
                                            _hoisted_89,
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn-close",
                                                "aria-label": "Close",
                                                onClick: _cache[21] || (_cache[21] = ($event) => (showDialogs.value.quoteColor = !showDialogs.value.quoteColor))
                                            }),
                                            _createVNode(_unref(ColorPicker), {
                                                color: _unref(calendarSettingsStore).quote.color,
                                                onColorChange: updateQuoteColor
                                            }, null, 8, ["color"])
                                        ], 512), [
                                            [_vShow, showDialogs.value.quoteColor]
                                        ]),
                                        _createElementVNode("div", _hoisted_90, [
                                            _hoisted_91,
                                            _createVNode(FontPicker, {
                                                defaultFont: _unref(calendarSettingsStore).quote.fontFace.fontName,
                                                onFontChanged: _cache[22] || (_cache[22] = ($event) => (_unref(calendarSettingsStore).quote.fontFace = $event))
                                            }, null, 8, ["defaultFont"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template' || _unref(route).name === 'premium_photo')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        _hoisted_93,
                                        _createElementVNode("div", {
                                            class: "picked-color text-center",
                                            style: _normalizeStyle({ 'background-color': _unref(calendarSettingsStore).title.shadowColor }),
                                            onClick: _cache[23] || (_cache[23] = ($event) => (showDialogs.value.borderColor = !showDialogs.value.borderColor))
                                        }, _hoisted_95, 4)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template' || _unref(route).name === 'premium_photo')
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_96, [
                                        _hoisted_97,
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn-close",
                                            "aria-label": "Close",
                                            onClick: _cache[24] || (_cache[24] = ($event) => (showDialogs.value.borderColor = !showDialogs.value.borderColor))
                                        }),
                                        _createVNode(_unref(ColorPicker), {
                                            color: _unref(calendarSettingsStore).title.shadowColor,
                                            onColorChange: updateBorderColor
                                        }, null, 8, ["color"])
                                    ], 512)), [
                                        [_vShow, showDialogs.value.borderColor]
                                    ])
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                        _hoisted_99,
                                        _createVNode(_unref(VueSimpleRangeSlider), {
                                            min: 0,
                                            max: 100,
                                            modelValue: _unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.shapeSize,
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.shapeSize) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                        _hoisted_101,
                                        _createElementVNode("div", {
                                            class: "picked-color text-center",
                                            style: _normalizeStyle({ 'background-color': _unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.shapeColor }),
                                            onClick: _cache[26] || (_cache[26] = ($event) => (showDialogs.value.watercolorShapeColor = !showDialogs.value.watercolorShapeColor))
                                        }, _hoisted_103, 4)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template')
                                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_104, [
                                        _hoisted_105,
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn-close",
                                            "aria-label": "Close",
                                            onClick: _cache[27] || (_cache[27] = ($event) => (showDialogs.value.watercolorShapeColor = !showDialogs.value.watercolorShapeColor))
                                        }),
                                        _createVNode(_unref(ColorPicker), {
                                            color: _unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].settings.shapeColor,
                                            onColorChange: updateWatercolorShapeColor
                                        }, null, 8, ["color"])
                                    ], 512)), [
                                        [_vShow, showDialogs.value.watercolorShapeColor]
                                    ])
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'watercolor_template')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                        _hoisted_107,
                                        _createElementVNode("img", {
                                            class: "shape-control",
                                            src: '/images/shapes/watercolor/' + _unref(calendarTemplatesStore).templates[1].settings.shapeFile,
                                            onClick: _cache[28] || (_cache[28] = ($event) => (showDialogs.value.watercolorShape = true))
                                        }, null, 8, _hoisted_108)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(route).name === 'premium_photo2')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                        _hoisted_110,
                                        _createElementVNode("img", {
                                            class: "bg-control",
                                            src: '/images/backgrounds/' + _unref(calendarTemplatesStore).templates[2].settings.headerBackgroundImage,
                                            onClick: _cache[29] || (_cache[29] = ($event) => (showDialogs.value.calBackground = true))
                                        }, null, 8, _hoisted_111),
                                        _createElementVNode("p", _hoisted_112, [
                                            _createElementVNode("button", {
                                                class: "btn btn-secondary btn-md mx-auto",
                                                type: "button",
                                                onClick: _cache[30] || (_cache[30] = ($event) => (showDialogs.value.calBackground = !showDialogs.value.calBackground))
                                            }, " Change Background ")
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _withDirectives(_createElementVNode("div", {
                            class: _normalizeClass(["preview-sheet mx-auto my-auto", _unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].name])
                        }, [
                            _createVNode(_component_router_view)
                        ], 2), [
                            [_vShow, showDialogs.value.calendarPreview]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["btn btn-secondary btn-md mx-auto fz-20", { disabled: ((!_unref(calendarImagesStore).imageSelected) && (_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].name != 'quotes_calendar')),
                                    cursor_not_allowed: ((!_unref(calendarImagesStore).imageSelected) && (_unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].name != 'quotes_calendar')) }]),
                            type: "button",
                            onClick: makeCalendarClick,
                            onMouseover: _cache[31] || (_cache[31] = ($event) => (showDialogs.value.makeButtonTooltip = true)),
                            onMouseleave: _cache[32] || (_cache[32] = ($event) => (showDialogs.value.makeButtonTooltip = false))
                        }, " Make This Calendar ", 34),
                        _withDirectives(_createElementVNode("div", _hoisted_117, [
                            _hoisted_118,
                            _createTextVNode(" Upload a photo first ")
                        ], 512), [
                            [_vShow, showDialogs.value.makeButtonTooltip && !_unref(calendarImagesStore).imageSelected && _unref(calendarTemplatesStore).templates[_unref(calendarTemplatesStore).templateIndex].name != 'quotes_calendar']
                        ])
                    ])
                ])
            ]));
        };
    }
});
